import { type ICouponRepository, type IGetCouponsUseCase, NotFoundError } from '../../../domain/entry.js';

type Execute = ReturnType<IGetCouponsUseCase['execute']>;
type GetSnapshotReturn = ReturnType<Execute[0]>;
type GetSubscribeReturn = ReturnType<Execute[1]>;

/**
 * Use case for getting the a collection of coupons based on a given coupon id.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for retrieving the collection
 */
export function getCouponsUseCase(couponRepository: ICouponRepository): IGetCouponsUseCase {
  return {
    execute: ({ couponId }): Execute => {
      return [
        (): GetSnapshotReturn => {
          const coupons = couponRepository.getCouponCollectionModels({ couponId });

          if (!coupons) {
            throw new NotFoundError(`Coupons not found for id: ${couponId}`);
          }

          return coupons;
        },
        // eslint-disable-next-line unicorn/consistent-function-scoping
        (): GetSubscribeReturn => () => {
          /* not implemented yes */
        },
      ] as const;
    },
  };
}
